module.exports = __webpack_public_path__ + "img/publish_xuqiu.9f36b45.png";